import { extend } from 'elemental-react';
import BaseCard from './BaseCard';
var FilledCard = extend(BaseCard, function () { return ({
    bg: '#222',
}); });
export default FilledCard;
